import { MeteringPointActDeviceSlim } from '@/features/meteringPointActs/types';
import { extractDataByPath } from '@/pages/ViolationActForm/hooks';

import { cleanData } from './cleanData';

export const getDevices = (
  devices = [],
  date: string,
  isEditMode?: boolean,
): Partial<MeteringPointActDeviceSlim>[] =>
  devices.map(device => {
    const getByPath = extractDataByPath(device);

    const standardConditionReading = parseFloat(
      getByPath('standardConditionReading'),
    );
    const workConditionReading = parseFloat(getByPath('workConditionReading'));

    const editModeIds =
      'meteringDevice' in device
        ? {
            meteringDeviceId: getByPath('meteringDevice.id'),
            id: getByPath('id', ''),
          }
        : {
            meteringDeviceId: getByPath('id'),
          };

    const createModeIds = {
      meteringDeviceId: getByPath('id', ''),
    };

    const deviceData = {
      action: getByPath('action'),
      certificateNumber: getByPath('certificateNumber', ''),
      date: getByPath('date', date),
      nextVerificationDate: getByPath('nextVerificationDate', ''),
      state: getByPath('state'),
      verificationDate: getByPath('verificationDate', ''),
      ...(isEditMode ? editModeIds : createModeIds),
      standardConditionReading,
      workConditionReading,
    };

    return cleanData(deviceData);
  });
